import React from 'react'
import { getMessage } from '../../../utils/index'

import './WebhookBoletoForm.scss'
import LtsInputText from '../../../components/lottus/lts-input-text'
import utils from '../../../utils'
import _ from 'lodash'
import LtsLookupConfiguracaoBoleto from '../../../components/lottus/lts-lookup-configuracao-boleto'
import { Checkbox } from 'primereact/checkbox'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Message } from 'primereact/message'
import { TabPanel, TabView } from 'primereact/tabview'
import { enums } from '../../../constants'
import { DataTableLog } from '../../../components/log/DataTableLog'

export const WebhookBoletoForm = (props) => {
  const record = props.record
  const messages = props.messages

  const filtroTipoBoleto = [
    enums.TipoBoleto.BRADESCO.codigo,
    enums.TipoBoleto.SICOOB.codigo,
    enums.TipoBoleto.BB.codigo,
  ]

  const getDadosGerais = () => {
    return (
      <div className="p-grid form-group">
        <div className="p-col-12">
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={record.descricao}
                onChange={(e) => props.onChangeDescricao(e)}
                name="descricao"
                autoFocus={true}
                maxLength={255}
                label={getMessage(messages, 'webhookboleto.label.descricao')}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsLookupConfiguracaoBoleto
                label={utils.getMessage(messages, 'webhookboleto.label.configuracaoboleto')}
                value={_.get(record, 'configuracaoBoleto.value', '')}
                oidRecord={_.get(record, 'configuracaoBoleto.id', '')}
                history={props.history}
                onChange={(e) => props.setConfiguracaoBoleto(e)}
                filtroTipoBoleto={filtroTipoBoleto}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-8 p-md-6 p-lg-4 p-xl-2">
              <Checkbox
                checked={record.ativo}
                onChange={(e) => props.onChangeField('ativo', e)}
                name="ativo"
                style={{ marginRight: '5px' }}
              />
              <label htmlFor="chkativo" className="label">
                {getMessage(messages, 'webhookboleto.label.ativo')}
              </label>
            </div>
          </div>

          {record.identificador && (
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
                <div className="flex flex-column gap-2">
                  <LtsInputText
                    value={record.identificador}
                    name="identificador"
                    autoFocus={false}
                    disabled={true}
                    label={getMessage(messages, 'webhookboleto.label.identificador')}
                  />
                  <small>{utils.getMessage(messages, 'webhookboleto.label.identificador.help')}</small>
                </div>
              </div>
            </div>
          )}

          {record.cadastroManual && (
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-8 p-lg-6 p-xl-6">
                <Message severity="info" text={utils.getMessage(messages, 'webhookboleto.label.cadastromanual.help')} />
              </div>
            </div>
          )}

          {record.urlWebhook && (
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-8 p-md-6 p-lg-6 p-xl-6">
                <div className="flex flex-column gap-2">
                  <label>{getMessage(messages, 'webhookboleto.label.urlwebhook')}</label>
                  <div className="p-inputgroup">
                    <InputText value={record.urlWebhook} disabled />
                    <Button
                      icon="pi pi-copy"
                      type="button"
                      tooltip="Copiar URL"
                      tooltipOptions={{ position: 'top' }}
                      onClick={() => navigator.clipboard.writeText(record.urlWebhook)}
                    />
                  </div>
                  <small>{utils.getMessage(messages, 'webhookboleto.label.urlwebhook.help')}</small>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  const getDadosLogs = () => {
    return (
      <div className="p-grid form-group">
        <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
          <DataTableLog record={record} tipoLog={enums.TipoLog.WEBHOOK} />
        </div>
      </div>
    )
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <div className="card card-w-title webhook-boleto-form">
          <h3>
            {utils.getMessage(messages, 'webhookboleto.label.webhookboleto')} {record.oid || ''}
          </h3>

          <TabView>
            <TabPanel header={utils.getMessage(messages, 'webhookboleto.label.dadosgerais')}>
              {getDadosGerais()}
            </TabPanel>
            {record.oid ? (
              <TabPanel header={utils.getMessage(messages, 'webhookboleto.label.logs')}>{getDadosLogs()}</TabPanel>
            ) : null}
          </TabView>
        </div>
      </div>
    </div>
  )
}
